module.exports = "<div class=\"welcome-bg\">\n  <img src=\"../../../assets/images/koululehtikone_logo.png\" class=\"kl-frontpage-logo\"/>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/welcome/welcome.component.html
// module id = 214
// module chunks = 1